import React from "react";

import { Box, Typography } from "@mui/material";
import Image from "../components/image/Image";

import image from "../resources/images/about/오시는길.png";

export default function AboutDirections(props) {
  // const nowMediaQuery = props.nowMediaQuery;
  return (
    <div className="section">
      {/* section 1 */}
      <section className="contents">
        <div>
          <Typography sx={{ mt: 15 }} variant="h5" color="black" mb={1}>
            <strong className="blue">해피인 오시는길</strong>
          </Typography>
          <Typography variant="subtitle1" fontSize={17} mb={1}>
            • 주소: 서울 관악구 신림로 19길 68
          </Typography>
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <a href="https://naver.me/5iT3okUN">
              <Image disabledEffect src={image} sx={{ borderRadius: 1 }} />
            </a>
          </Box>
        </div>
      </section>

      {/* section 2 */}
      <section className="contents">
        <div>
          <Typography variant="h5" color="black" mb={1}>
            <strong className="blue">대중교통 이용방법</strong>
          </Typography>

          <Typography variant="subtitle1" fontSize={17}>
            • 주소: 서울 관악구 신림로 19길 68
            <br />• 2호선 신림역 3번출구 {">"} 버스 152, 5522번 미림여고 하차
            <br />• 2호선 서울대역 3번출구 {">"} 버스 6515, 5517번 미림여고 하차
            <br />
            {"   > "} 길건너 미림여고 왼쪽길 200m, 삼거리에서 좌측길 50m
            (선민교회 옆)
            <br /> • 전화번호: 0507-1321-6216 / 010-5271-6216
            <br />• 운영 시간: 월요일 ~ 금요일: 10:00 ~18:00
          </Typography>
        </div>
      </section>
    </div>
  );
}
